import { useState } from "react";
import './Tabs.scss';
import { AnimatePresence, LayoutGroup, motion } from "motion/react";

/**
 * 
 * @param {{tabs:Array<{id:Number, title:String, content:import("react").ReactElement | string}>}} param0 
 * @returns 
 */
export function Tabs({ children, selectedTab, tabs = [], className = '' }) {
    const [_selectedTab, setSelectedTab] = useState(selectedTab !== undefined ? selectedTab : tabs[0].id);

    return <div className={`Tabs ${className}`}>

        <div className="Tabs__tabs">
            {tabs.map((tab, index) => {
                return <Tab onClick={e => {
                    e.preventDefault();
                    setSelectedTab(tab.id);
                }}
                    className={_selectedTab === tab.id ? 'active' : ''}
                    key={index}
                    selectedId={_selectedTab}
                    tabId={tab.id}>{tab.title}</Tab>
            })}
        </div>
        <AnimatePresence mode="wait" className="Tabs__contents">
            {tabs.map((tab, index) => {
                if (_selectedTab !== tab.id) {
                    return null
                }
                return <TabContent
                    key={index}
                    tabId={tab.id}
                    className={_selectedTab === tab.id ? 'active' : ''}
                >{tab.content}</TabContent>
            })}
        </AnimatePresence>

    </div>
}

export function Tab({ children, tabId, selectedId, onClick, className = '' }) {
    var classes = [];
    if (className) {
        classes.push(className);
    }

    return <div className={classes.join(' ')} onClick={onClick}>
        {children}
        {tabId === selectedId ? (
            <motion.div
                style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 1,
                    background: "var(--dark-accent)",
                    zIndex: 2
                }}
                layoutId="underline"
                id="underline"
            />
        ) : null}
    </div>
}



export function TabContent({ children, tabId, className = '' }) {
    var classes = ['TabContent'];
    if (className) {
        classes.push(className);
    }

    return <motion.div
        initial={{ x: 10, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -10, opacity: 0 }}
        transition={{ duration: 0.2 }}
        className={classes.join(' ')}>
        {children}
    </motion.div>
}